module.exports = __webpack_public_path__ + "static/clubrare-8bb2efaf7ef81b69c40f87c641fc1c7c.svg";